import { render, staticRenderFns } from "./ModelEditor.vue?vue&type=template&id=14505518&scoped=true"
import script from "./ModelEditor.vue?vue&type=script&lang=js"
export * from "./ModelEditor.vue?vue&type=script&lang=js"
import style0 from "./ModelEditor.vue?vue&type=style&index=0&id=14505518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14505518",
  null
  
)

export default component.exports